import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import * as L from 'leaflet';
import { RouteService } from '../../services/route.service';
import { MapService } from '../../services/map.service';
import { KmlService } from '../../services/kml.service';
import { MarkersService } from '../../services/markers.service';
import { StopsService } from '../../services/stops.service';
import { timer } from 'rxjs';

@Component({
  selector: 'app-embedded-map',
  templateUrl: './embedded-map.component.html',
  styleUrls: ['./embedded-map.component.css']
})
export class EmbeddedMapComponent implements AfterViewInit {
  private map: any;
  public current_position: any = null;
  private detailed: any;
  private id: string;
  public schedule: any = [{ 'block_id': null, trip_headsign: "" }];
  public selected_direction: any = 0;
  public selected_stop: any;

  private transitRefresh: any;

  constructor(private routeService: RouteService, private mapService: MapService, private kmlService: KmlService, private markersService: MarkersService, private router: Router, private route: ActivatedRoute, private stopsService: StopsService) {

    this.id = this.route.snapshot.paramMap.get('route');
    this.selected_direction = this.route.snapshot.paramMap.get('direction');
    this.selected_stop = this.route.snapshot.paramMap.get('stop');
    //console.log("The route is " + this.router.url.substring(1, 10));

  }

  ngAfterViewInit(): void {
    this.mapService.initMap();
    if (this.mapService.map != null) {
      this.mapService.map.off();
      this.mapService.map.remove();
    }

    this.mapService.initMap();


    if (this.id != null) {
      this.routeService.getStatic(this.id).subscribe(routes => {
        this.detailed = routes[0];
        this.detailed = { id: this.id, name: routes[0]['route_name'], mode: routes[0]['mode'] };

        if (this.selected_stop != undefined) {
          this.kmlService.get(this.mapService.map, this.detailed, false);

          this.markersService.addStopMarkers(this.mapService.map, this.id, this.selected_direction, this.selected_stop);
        }
        else {
          this.kmlService.get(this.mapService.map, this.detailed, true);
        }

        this.transitRefresh = timer(1000, 5000).subscribe(t => {
          this.markersService.fetch(this.mapService.map, this.detailed);
        });
      });
    }
    else {
      this.detailed = this.routeService.detailed;
      this.kmlService.get(this.mapService.map, this.detailed);

      this.transitRefresh = timer(1000, 5000).subscribe(t => {
        this.markersService.fetch(this.mapService.map, this.detailed);
      });
    }

  }

  ngOnDestroy() {
    this.transitRefresh.unsubscribe();
  }
  
}
